module.exports = __webpack_public_path__ + "media/images/landings/promotion_3/img_icon-01-b1c7fbae200d72a653feeaaf86043507.png";